
import { Loader2 } from 'lucide-react';
import { ApplicationCard } from './ApplicationCard';
import type { Application } from '@/types/database.types';

interface ApplicationListProps {
  applications: Application[];
  isLoading: boolean;
  onView: (applicationId: string) => void;
  onResetRequest: (applicationId: string) => void;
  onDeleteRequest: (applicationId: string) => void;
  onSubmit: (applicationId: string) => void;
  isActionInProgress: boolean;
}

export const ApplicationList = ({
  applications,
  isLoading,
  onView,
  onResetRequest,
  onDeleteRequest,
  onSubmit,
  isActionInProgress
}: ApplicationListProps) => {
  if (isLoading && (!applications || applications.length === 0)) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold sm:text-3xl">Applications</h1>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {applications.map((application) => (
          <ApplicationCard
            key={application.id}
            application={application}
            onView={onView}
            onResetRequest={onResetRequest}
            onDeleteRequest={onDeleteRequest}
            onSubmit={onSubmit}
            isActionInProgress={isActionInProgress}
          />
        ))}
      </div>
    </div>
  );
};
